'use client'

import { createContext, useContext, useState, type ReactNode } from 'react'

const DialogPortalContainerContext = createContext<HTMLElement | null>(null)

/** Mounts combobox/select popups inside a Radix dialog so they stay interactive. */
export function DialogPortalContainer({ children }: { children: ReactNode }) {
  const [container, setContainer] = useState<HTMLElement | null>(null)

  return (
    <DialogPortalContainerContext.Provider value={container}>
      <div ref={setContainer} className="contents" />
      {children}
    </DialogPortalContainerContext.Provider>
  )
}

export function useDialogPortalContainer(): HTMLElement | null {
  return useContext(DialogPortalContainerContext)
}
